import styled from 'styled-components';
import { BottomSns } from '../../common/BottomSnsImg';
import { ImageUtils } from '../../../utils/ImageUtils';
import { mobileQuery } from '../../../utils';

export const RewardInfo = () => {
  return (
    <>
      <Wrap>
        <TextContainer>
          <TotalRewardText>
            300,000,000
            <Unit>GTD</Unit>
          </TotalRewardText>
        </TextContainer>

        <LabelRed>
          <LabelText>온라인 새틀라이트</LabelText>
        </LabelRed>

        <EventRow>
          <EventInfoLeft>
            <EventTitleRed>메인 새틀라이트</EventTitleRed>
            <EventPrize>250,000,000 GTD</EventPrize>
          </EventInfoLeft>
          <EventInfoRight>
            <EventDate>2025년 4월 29일(화) ~ 5월 6일(화)</EventDate>
            <EventVenue>피망 쇼다운 홀덤 앱</EventVenue>
          </EventInfoRight>
        </EventRow>

        <EventRow>
          <EventInfoLeft>
            <EventTitleRed>사이드 새틀라이트</EventTitleRed>
            <EventPrize>50,000,000 GTD</EventPrize>
          </EventInfoLeft>
          <EventInfoRight>
            <EventDate>2025년 5월 2일(금) ~ 6일(화)</EventDate>
            <EventVenue>피망 쇼다운 홀덤 앱</EventVenue>
          </EventInfoRight>
        </EventRow>

        <LabelBlue>
          <LabelText>오프라인 이벤트</LabelText>
        </LabelBlue>

        <EventRow>
          <EventInfoLeft>
            <EventTitleBlue>메인 이벤트</EventTitleBlue>
            <EventVenue>인천 파라다이스 시티</EventVenue>
          </EventInfoLeft>
          <EventInfoRight>
            <EventDays>
              <span>DAY1</span> 5월 17일(토)
              <br />
              <span>DAY2</span> 5월 18일(일)
            </EventDays>
          </EventInfoRight>
        </EventRow>

        <EventRow>
          <EventInfoLeft>
            <EventTitleBlue>사이드 이벤트</EventTitleBlue>

            <EventVenue>인천 파라다이스 시티</EventVenue>
          </EventInfoLeft>
          <EventInfoRight>
            <EventDate>5월 16일(금)</EventDate>
          </EventInfoRight>
        </EventRow>

        <PartnerSection>
          <PartnerRow>
            <TitleContainer>
              <PartnerTitle>주최</PartnerTitle>
            </TitleContainer>
            <PartnerLogo>
              <PartnerIcon1 src={ImageUtils.PartnerIcon1} alt="KPS" />
            </PartnerLogo>
          </PartnerRow>

          <PartnerRow>
            <TitleContainer>
              <PartnerTitle>주관대행</PartnerTitle>
            </TitleContainer>
            <PartnerLogo>
              <PartnerIcon2 src={ImageUtils.PartnerIcon2} alt="KPS" />
            </PartnerLogo>
          </PartnerRow>

          <PartnerRow>
            <TitleContainer>
              <PartnerTitle>장소</PartnerTitle>
            </TitleContainer>
            <PartnerLogo>
              <PartnerIcon3 src={ImageUtils.PartnerIcon3} alt="KPS" />
            </PartnerLogo>
          </PartnerRow>

          <PartnerRow>
            <TitleContainer>
              <PartnerTitle>후원</PartnerTitle>
            </TitleContainer>
            <PartnerLogo>
              <PartnerIcon4 src={ImageUtils.PartnerIcon4} alt="KPS" />
            </PartnerLogo>
          </PartnerRow>
        </PartnerSection>
      </Wrap>
      <BottomSns />
    </>
  );
};

const TextContainer = styled.div`
  background: linear-gradient(249deg, #ffe993 18.33%, #ffbe46 78.59%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 17px;
  margin-top: 40px;

  ${mobileQuery} {
    margin-top: 0;
    margin-bottom: 0px;
  }
`;

const TotalRewardText = styled.h2`
  font-size: 64px;
  font-weight: 800;
  line-height: 87px;

  ${mobileQuery} {
    font-size: 43px;
    line-height: 74px;
  }
`;

const Unit = styled.span`
  font-size: 48px;
  font-weight: 900;
  margin-left: 10px;

  ${mobileQuery} {
    font-size: 30px;
    margin-left: 5px;
  }
`;

const Wrap = styled.div`
  text-align: center;
  padding-bottom: 150px;
  max-width: 820px;
  margin: 0 auto;

  ${mobileQuery} {
    padding-top: 0px;
    padding-right: 10px;
    padding-left: 10px;
  }
`;

const Label = styled.div`
  height: 40px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  ${mobileQuery} {
    height: 21px;
  }
`;

const LabelRed = styled(Label)`
  border-top: 1px solid #d92a76;
  border-bottom: 1px solid #d92a76;
  background: linear-gradient(90deg, rgba(201, 0, 80, 0.7) 25.71%, rgba(164, 0, 71, 0.7) 86.89%);
`;

const LabelBlue = styled(Label)`
  border-top: 1px solid #1e95f6;
  border-bottom: 1px solid #1e95f6;
  background: linear-gradient(91deg, rgba(0, 155, 251, 0.8) 10.71%, rgba(0, 114, 207, 0.8) 84.3%);
`;

const LabelText = styled.p`
  font-weight: 500;
  font-size: 18px;
  color: rgba(255, 255, 255, 0.9);
  margin: 0;

  ${mobileQuery} {
    font-size: 12px;
    line-height: 21px;
  }
`;

const EventRow = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 15px 10px;
  text-align: left;
  margin-bottom: 2px;
  background-color: #222;
  width: 100%;
  &:last-child {
    margin-bottom: 0;
  }

  ${mobileQuery} {
    padding: 0px 10px;
    padding-top: 5px;
    padding-bottom: 12px;
  }
`;

const EventInfoLeft = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const EventInfoRight = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const EventTitleRed = styled.h3`
  font-size: 20px;
  font-weight: 400;
  color: #ff63a2;

  ${mobileQuery} {
    font-size: 14px;
  }
`;

const EventTitleBlue = styled.h3`
  font-size: 20px;
  font-weight: 400;
  color: #47acff;

  ${mobileQuery} {
    font-size: 14px;
  }
`;

const EventDate = styled.p`
  font-size: 20px;
  color: rgba(255, 255, 255, 0.8);
  margin: 0;

  ${mobileQuery} {
    font-size: 13px;
  }
`;

const EventDays = styled.p`
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 400;

  span {
    font-weight: 600;
  }
  ${mobileQuery} {
    font-size: 13px;
  }
`;

const EventPrize = styled.p`
  font-size: 20px;
  font-weight: 600;
  color: #ffbe46;

  ${mobileQuery} {
    font-size: 15px;
  }
`;

const EventVenue = styled.p`
  font-size: 20px;
  color: rgba(255, 255, 255, 0.8);
  margin: 0;

  ${mobileQuery} {
    font-size: 13px;
  }
`;

const PartnerSection = styled.div`
  margin-top: 20px;
  display: flex;

  ${mobileQuery} {
    flex-wrap: wrap;

    > div:nth-child(even) {
      border-right: none;
    }

    > div:nth-child(3) {
      border-bottom: 1px solid #000000;
    }

    > div:nth-child(4) {
      border-bottom: 1px solid #000000;
    }
  }
`;

const PartnerRow = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  ${mobileQuery} {
    flex-basis: 50%;
    border-right: 1px solid #000000;
  }
`;

const TitleContainer = styled.div`
  background: rgba(0, 0, 0, 0.1);
  height: 48px;
  border-bottom: 1px solid #000000;
  border-top: 1px solid #000000;
  display: flex;
  align-items: center;
  justify-content: center;

  ${mobileQuery} {
    height: 24px;
  }
`;

const PartnerTitle = styled.h3`
  font-weight: 500;
  font-size: 20px;
  letter-spacing: -0.04em;
  color: rgba(255, 255, 255, 0.8);
  font-family: 'Gmarket Sans TTF';

  &:last-child {
    margin-right: 0;
  }

  ${mobileQuery} {
    font-size: 12px;
    line-height: 24px;
  }
`;

const PartnerLogo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px 0;
  height: 110px;
  background: rgba(0, 0, 0, 0.2);

  img {
    max-width: 80%;
    max-height: 80px;
    margin: 0 5px;
  }

  ${mobileQuery} {
    height: 55px;
  }
`;

const PartnerIcon1 = styled.img`
  width: 104px;
`;
const PartnerIcon2 = styled.img`
  width: 64px;
`;
const PartnerIcon3 = styled.img`
  width: 104px;
`;
const PartnerIcon4 = styled.img`
  width: 68px;
`;
